module.exports = __webpack_public_path__ + "img/cat3.c6414da2.jpg";